module.exports = __webpack_public_path__ + "img/logo.ef345179.png";